import type { TemplateOnlyComponent as TOC } from '@ember/component/template-only';
import { t } from 'ember-intl';
import SettingsMyHotelFormGeneralDefaults from 'lumen/components/settings/my-hotel/form-general-defaults';
import SettingsPageTemplate from 'lumen/components/settings/page-template';
import type HotelSettingsMyPropertyGeneralDefaultsController from 'lumen/controllers/hotel/settings/my-property/general-defaults';

interface HotelSettingsMyPropertyGeneralDefaultsSignature {
  Args: {
    controller: HotelSettingsMyPropertyGeneralDefaultsController;
  };
}

const HotelSettingsMyPropertyGeneralDefaultsTemplate = <template>
  <SettingsPageTemplate
    @description={{t "settings.my_hotel.general_defaults.description"}}
    @title={{t "settings.my_hotel.general_defaults.title"}}
    @type="container"
  >
    <SettingsMyHotelFormGeneralDefaults @model={{@controller.model}} />
  </SettingsPageTemplate>
</template> satisfies TOC<HotelSettingsMyPropertyGeneralDefaultsSignature>;

export default HotelSettingsMyPropertyGeneralDefaultsTemplate;
